module.exports = __webpack_public_path__ + "assets/img/9eca93606555f13d96bc65f5153a6079.svg";